import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faDiscord,
  faFacebook,
  faFacebookSquare,
  faGithubSquare,
  faGoogle,
  faItchIo,
  faRedditAlien,
  faSteamSymbol,
  faTwitter,
  faTwitterSquare,
  faXbox,
  faYoutube,
  faPlaystation,
  faGithub,
  faPaypal,
} from '@fortawesome/free-brands-svg-icons'

import {
  faTimesCircle as farTimeCircle,
  faEdit as farEdit,
  faEye as farEye,
  faMoon as farMoon,
} from '@fortawesome/free-regular-svg-icons'

import {
  faEyeSlash,
  faUserMinus,
  faUserPlus,
  faCubes,
  faComment,
  faFile,
  faServer,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faCalendarDay,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCode,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileArchive,
  faFileDownload,
  faFileUpload,
  faFilter,
  faFlag,
  faGamepad,
  faHome,
  faImage,
  faInfo,
  faInfoCircle,
  faKey,
  faLink,
  faList,
  faLock,
  faMinus,
  faMinusCircle,
  faPencilAlt,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRedoAlt,
  faSearch,
  faShareAlt,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faSyncAlt,
  faTag,
  faTags,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTrash,
  faUserCircle,
  faUser,
  faUsers,
  faBookOpen,
  faSortAmountDown,
  faCalendarAlt,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'

const brandIcons = [
  faDiscord,
  faFacebook,
  faFacebookSquare,
  faGithubSquare,
  faGoogle,
  faItchIo,
  faRedditAlien,
  faSteamSymbol,
  faTwitter,
  faTwitterSquare,
  faXbox,
  faYoutube,
  faPlaystation,
  faGithub,
  faPaypal,
]

const regularIcons = [farTimeCircle, farEdit, farEye, farMoon]

const solidIcons = [
  faEyeSlash,
  faUserMinus,
  faUserPlus,
  faCubes,
  faUpload,
  faCalendarAlt,
  faSortAmountDown,
  faBookOpen,
  faComment,
  faFile,
  faServer,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faCalendarDay,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCode,
  faCog,
  faDatabase,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFileAlt,
  faFileArchive,
  faFileDownload,
  faFileUpload,
  faFilter,
  faFlag,
  faGamepad,
  faHome,
  faImage,
  faInfo,
  faInfoCircle,
  faKey,
  faLink,
  faList,
  faLock,
  faMinus,
  faMinusCircle,
  faPlus,
  faPlusCircle,
  faPencilAlt,
  faQuestionCircle,
  faRedoAlt,
  faSearch,
  faShareAlt,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faSyncAlt,
  faTag,
  faTags,
  faTrash,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faUserCircle,
  faUser,
  faUsers,
]

export const installedIcons = [
  ...brandIcons.map((icon) => ['fab', icon.iconName]),
  ...solidIcons.map((icon) => icon.iconName),
  ...regularIcons.map((icon) => ['far', icon.iconName]),
]

library.add(...brandIcons, ...solidIcons, ...regularIcons)

export default FontAwesomeIcon
